module.exports = __webpack_public_path__ + "media/images/workplace/social-ico/apple-ico-872122ee9c6e755e5a414b9ba484771e.svg";